{
    "previous": "Anterior",
    "next": "Siguiente",
    "go5back": "Retroceder 5",
    "go5next": "Avanzar 5",
    "items": "artículos",
    "itemsPerPage": "artículos por página"
}